import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    publishableKey: String
  }

  static targets = ["cardElement", "cardErrors", "submitButton"]

  connect() {
    // Initialize Stripe with publishable key
    this.stripe = Stripe(this.publishableKeyValue)

    // Create Stripe credit card elements
    const elements = this.stripe.elements()
    this.card = elements.create('card', { hidePostalCode: true })

    // Add change listener to check for errors
    this.card.addEventListener('change', (event) => {
      this.submitButtonTarget.disabled = false

      if (event.error) {
        this.cardErrorsTarget.textContent = event.error.message
      } else {
        this.cardErrorsTarget.textContent = ''
      }
    })

    // Mount Stripe card element
    this.card.mount(this.cardElementTarget)
  }

  async submit(event) {
    event.preventDefault()

    // Disable submit button
    this.submitButtonTarget.disabled = true

    try {
      // Create Stripe token
      const result = await this.stripe.createToken(this.card)

      if (result.error) {
        // Show error and re-enable button
        this.cardErrorsTarget.textContent = result.error.message
        this.submitButtonTarget.disabled = false
      } else {
        // Add token to form and submit
        console.log('Stripe token created:', result.token.id)
        this.addTokenToForm(result.token.id)
        this.element.submit()
      }
    } catch (error) {
      console.error('Stripe error:', error)
      this.cardErrorsTarget.textContent = 'An error occurred. Please try again.'
      this.submitButtonTarget.disabled = false
    }
  }

  addTokenToForm(tokenId) {
    const tokenInput = document.createElement('input')
    tokenInput.type = 'hidden'
    tokenInput.name = 'subscription_form[token]'
    tokenInput.value = tokenId
    this.element.appendChild(tokenInput)
  }

  disconnect() {
    if (this.card) {
      this.card.destroy()
    }
  }
}
